import { Component } from '@theme/component';

/**
 * A custom element that manages a single shared modal for product media.
 *
 * Wraps a `dialog-component` and exposes `openForMedia(mediaId)`, which clones
 * the matching `<template id="product-media-content-{mediaId}">` into the modal
 * content area before opening the dialog.
 *
 * Usage in Liquid:
 *   on:click="#modal-id/openForMedia/{{ media.id }}"
 */
export class ProductMediaModal extends Component {
  connectedCallback() {
    super.connectedCallback();

    // The slideshow's mousedown handler calls setPointerCapture on any pointer
    // movement, redirecting pointerup to itself and preventing click from firing
    // on the button. Stopping mousedown at the button level (target phase) keeps
    // it from ever reaching the slideshow's scroller. This runs on every
    // (re)connection so variant-triggered gallery replacements are also covered.
    this.closest('media-gallery')
      ?.querySelectorAll('.product-media__overlay-button')
      .forEach((btn) => {
        btn.addEventListener('mousedown', (e) => e.stopPropagation());
      });
  }

  /**
   * Injects per-media content and opens the dialog.
   *
   * @param {string|number} mediaId - The media ID whose <template> should be loaded.
   */
  openForMedia(mediaId) {
    const template = document.getElementById(`product-media-content-${mediaId}`);

    if (template instanceof HTMLTemplateElement) {
      const content = this.querySelector('.product-media__modal-content');
      if (content) content.replaceChildren(template.content.cloneNode(true));
    }

    const dialogComponent = /** @type {import('./dialog.js').DialogComponent | null} */ (this.querySelector('dialog-component'));
    dialogComponent?.showDialog();
  }
}

if (!customElements.get('product-media-modal')) {
  customElements.define('product-media-modal', ProductMediaModal);
}

